<template>
  <div class="listings-listing-card">
    <div class="flex flex-col h-full">
      <div class="image">
        <img :src="listing.thumbnail_url" class="cover" v-if="listing.thumbnail_url" :alt="listing.space_name"/>
      </div>
      <h3 class="title font-castoro">
        <span>
            {{ listing.space_name }}
        </span>
      </h3>
      <h4
        class="wt-std location"
        v-if="listing.address_label"
      >
        <div class="address-label">{{ listing.address_label }}</div>
      </h4>

      <div class="actions">
        <div @click="editListing" class="edit-listing-btn button primary">
          Edit Property
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      listing: {
        type: Object,
        required: true
      }
    },
    methods: {
      editListing() {
        this.$store.dispatch('modals/showAddListing', {
          edit: this.listing.id
        })
      }
    }
  }
</script>
